'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var en = {
    "Autocomplete.add": 'Add "{value}"',
    "Autocomplete.all_number_selected": "All {number} selected",
    "Autocomplete.all_number": "All ({number})",
    "Card.toggle_content": "toggle content",
    "Chip.remove": "remove",
    "DatePicker.next": "Next",
    "DatePicker.previous": "Previous",
    "Pagination.first": "first",
    "Pagination.go_to_page_number": "Go to page {index}",
    "Pagination.go_to_page": "Go to {label} page",
    "Pagination.last": "last",
    "Pagination.next": "next",
    "Pagination.previous": "previous",
    "Table.actions": "Table Actions",
    "Table.add_column": "Add Column",
    "Table.filter": "Filter",
    "Table.hide": "Hide",
    "Table.more_actions": "More Actions",
    "Table.move_left": "Move Left",
    "Table.move_right": "Move Right",
    "Table.not_specified": "Not specified",
    "Table.pagination": "Table Pagination",
    "Table.per_page": "Per page",
    "Table.position_zero": "0 of {total}",
    "Table.position": "{start}-{end} of {total}",
    "Table.search": "Search",
    "Table.select_all": "Select All",
    "Table.select_row": "Select {row}",
    "Table.sort_ascending": "Sort ascending",
    "Table.sort_descending": "Sort descending",
    "TextInput.clear_labelled_input": "Clear {label}",
    "Ui.clear_all": "Clear all",
    "Ui.close": "Close",
    "Ui.loading": "Loading",
    "Ui.no_results": "No results",
    "Ui.number_selected": "{number} selected",
    "Ui.remove": "Remove",
    "Ui.select_all": "Select all",
    "Ui.show_more": "+ {count} More",
};

var es = {
    "Autocomplete.all_number_selected": "Los {number} seleccionados",
    "Autocomplete.all_number": "Los ({number})",
    "Card.toggle_content": "alternar contenido",
    "Chip.remove": "retirar",
    "DatePicker.next": "Próximo",
    "DatePicker.previous": "Previo",
    "Pagination.first": "primero",
    "Pagination.go_to_page_number": "Ir a la página {index}",
    "Pagination.go_to_page": "Ir a la {label} pagina",
    "Pagination.last": "último",
    "Pagination.next": "próximo",
    "Pagination.previous": "previo",
    "Table.actions": "Acciones de tabla",
    "Table.add_column": "Añadir columna",
    "Table.filter": "Filter",
    "Table.hide": "Esconder",
    "Table.more_actions": "Mas acciones",
    "Table.move_left": "Mover hacia la izquierda",
    "Table.move_right": "Mover a la derecha",
    "Table.not_specified": "No especificado",
    "Table.pagination": "Paginación de tablas",
    "Table.per_page": "Por página",
    "Table.position_zero": "0 de {total}",
    "Table.position": "{start}-{end} de {total}",
    "Table.search": "Buscar",
    "Table.select_all": "Seleccionar todo",
    "Table.select_row": "Seleccione {row}",
    "Table.sort_ascending": "Orden ascendente",
    "Table.sort_descending": "Orden descendiente",
    "TextInput.clear_labelled_input": "Limpiar {label}",
    "Ui.clear_all": "Limpiar todo",
    "Ui.close": "Cerca",
    "Ui.loading": "Cargando",
    "Ui.no_results": "No hay resultados",
    "Ui.number_selected": "{number} seleccionados",
    "Ui.remove": "Remover",
    "Ui.select_all": "Seleccionar todo",
    "Ui.show_more": "+ {count} Más",
};

var fr = {
    "Autocomplete.all_number_selected": "Tous les {number} sélectionnés",
    "Autocomplete.all_number": "Tout ({number})",
    "Card.toggle_content": "basculer le contenu",
    "Chip.remove": "supprimer",
    "DatePicker.next": "Prochain",
    "DatePicker.previous": "Précédent",
    "Pagination.first": "premier",
    "Pagination.go_to_page_number": "Aller à la page {index}",
    "Pagination.go_to_page": "Aller à la {label} page",
    "Pagination.last": "Dernier",
    "Pagination.next": "Prochain",
    "Pagination.previous": "Précédent",
    "Table.actions": "Tableau des actions",
    "Table.add_column": "Ajouter une colonne",
    "Table.filter": "Filtre",
    "Table.hide": "Cacher",
    "Table.more_actions": "Plus d'actions",
    "Table.move_left": "Déplacer à gauche",
    "Table.move_right": "Déplacer vers la droite",
    "Table.not_specified": "Non précisé",
    "Table.pagination": "Pagination des tableaux",
    "Table.per_page": "Par page",
    "Table.position_zero": "0 sur {total}",
    "Table.position": "{start}-{end} sur {total}",
    "Table.search": "Chercher",
    "Table.select_all": "Tout sélectionner",
    "Table.select_row": "Sélectionnez {row}",
    "Table.sort_ascending": "Trier par ordre croissant",
    "Table.sort_descending": "Trier par ordre décroissant",
    "TextInput.clear_labelled_input": "Effacer {label}",
    "Ui.clear_all": "Tout effacer",
    "Ui.close": "Proche",
    "Ui.loading": "Chargement",
    "Ui.no_results": "Aucun résultat",
    "Ui.number_selected": "{number} sélectionnés",
    "Ui.remove": "Éliminer",
    "Ui.select_all": "Tout sélectionner",
    "Ui.show_more": "+ {count} Plus",
};

var ko = {
    "Autocomplete.all_number_selected": "모든 {number} 선택됨",
    "Autocomplete.all_number": "모두({number})",
    "Card.toggle_content": "콘텐츠 전환",
    "Chip.remove": "제거하다",
    "DatePicker.next": "다음",
    "DatePicker.previous": "이전의",
    "Pagination.first": "첫 번째",
    "Pagination.go_to_page_number": "페이지 {index}로 이동",
    "Pagination.go_to_page": "{label} 페이지로 이동",
    "Pagination.last": "마지막",
    "Pagination.next": "다음",
    "Pagination.previous": "이전의",
    "Table.actions": "테이블 작업",
    "Table.add_column": "열 추가",
    "Table.filter": "필터",
    "Table.hide": "숨다",
    "Table.more_actions": "더 많은 행동",
    "Table.move_left": "왼쪽으로 이동",
    "Table.move_right": "오른쪽으로 이동해라",
    "Table.not_specified": "명시되지 않은",
    "Table.pagination": "테이블 페이지 매김",
    "Table.per_page": "페이지 당",
    "Table.position_zero": "0/{total}",
    "Table.position": "{start}-{end}/{total}",
    "Table.search": "찾다",
    "Table.select_all": "모두 선택",
    "Table.select_row": "{row} 선택",
    "Table.sort_ascending": "오름차순 정렬",
    "Table.sort_descending": "내림차순 정렬",
    "TextInput.clear_labelled_input": "{label} 지우기",
    "Ui.clear_all": "모두 지우기",
    "Ui.close": "닫다",
    "Ui.loading": "로드 중",
    "Ui.no_results": "결과 없음",
    "Ui.number_selected": "{number} 선택됨",
    "Ui.remove": "제거하다",
    "Ui.select_all": "모두 선택",
    "Ui.show_more": "+ {count} 더보기"
};

var pl = {
    "Autocomplete.all_number_selected": "Wybrano wszystkie {number}",
    "Autocomplete.all_number": "Wszystkie ({number})",
    "Card.toggle_content": "przełącz zawartość",
    "Chip.remove": "usunąć",
    "DatePicker.next": "Następny",
    "DatePicker.previous": "Poprzedni",
    "Pagination.first": "Pierwszy",
    "Pagination.go_to_page_number": "Przejdź do strony {index}",
    "Pagination.go_to_page": "Przejdź do strony {label}",
    "Pagination.last": "ostatni",
    "Pagination.next": "Następny",
    "Pagination.previous": "poprzedni",
    "Table.actions": "Akcje tabeli",
    "Table.add_column": "Dodaj kolumnę",
    "Table.filter": "Filtr",
    "Table.hide": "Ukrywać",
    "Table.more_actions": "Więcej akcji",
    "Table.move_left": "Przesuń w lewo",
    "Table.move_right": "Ruch w prawo",
    "Table.not_specified": "Nieokreślony",
    "Table.pagination": "Paginacja tabeli",
    "Table.per_page": "Na stronę",
    "Table.position_zero": "0 z {total}",
    "Table.position": "{start}-{end} z {total}",
    "Table.search": "Szukaj",
    "Table.select_all": "Zaznacz wszystko",
    "Table.select_row": "Wybierz {row}",
    "Table.sort_ascending": "Sortuj rosnąco",
    "Table.sort_descending": "Sortuj malejąco",
    "TextInput.clear_labelled_input": "Wyczyść {label}",
    "Ui.clear_all": "Wyczyść wszystko",
    "Ui.close": "Zamknąć",
    "Ui.loading": "Ładowanie",
    "Ui.no_results": "Brak wyników",
    "Ui.number_selected": "Wybrano {number}",
    "Ui.remove": "Usunąć",
    "Ui.select_all": "Zaznacz wszystko",
    "Ui.show_more": "+ {count} Więcej"
};

var pt = {
    "Autocomplete.all_number_selected": "Todos os {number} selecionados",
    "Autocomplete.all_number": "Todos ({number})",
    "Card.toggle_content": "alternar conteúdo",
    "Chip.remove": "remover",
    "DatePicker.next": "Próximo",
    "DatePicker.previous": "Anterior",
    "Pagination.first": "primeiro",
    "Pagination.go_to_page_number": "Vá para a página {index}",
    "Pagination.go_to_page": "Ir para a página {label}",
    "Pagination.last": "durar",
    "Pagination.next": "próximo",
    "Pagination.previous": "anterior",
    "Table.actions": "Ações da tabela",
    "Table.add_column": "Adicionar coluna",
    "Table.filter": "Filtro",
    "Table.hide": "Esconder",
    "Table.more_actions": "Mais ações",
    "Table.move_left": "Mova para a esquerda",
    "Table.move_right": "Mover para a direita",
    "Table.not_specified": "Não especificado",
    "Table.pagination": "Paginação da Tabela",
    "Table.per_page": "Por página",
    "Table.position_zero": "0 de {total}",
    "Table.position": "{start}-{end} de {total}",
    "Table.search": "Procurar",
    "Table.select_all": "Selecionar tudo",
    "Table.select_row": "Selecione {row}",
    "Table.sort_ascending": "Ordernar ascendente",
    "Table.sort_descending": "Ordernar decrescente",
    "TextInput.clear_labelled_input": "Limpar {label}",
    "Ui.clear_all": "Limpar tudo",
    "Ui.close": "Fechar",
    "Ui.loading": "Carregando",
    "Ui.no_results": "Sem resultados",
    "Ui.number_selected": "{number} selecionado",
    "Ui.remove": "Remover",
    "Ui.select_all": "Selecionar tudo",
    "Ui.show_more": "+ {count} Mais"
};

var ru = {
    "Autocomplete.all_number_selected": "Выбрано {number, plural, one {все} other {все {number}}}",
    "Autocomplete.all_number": "Все ({number})",
    "Card.toggle_content": "показать/спрятать содержимое",
    "Chip.remove": "удалить",
    "DatePicker.next": "Следующий",
    "DatePicker.previous": "Предыдущий",
    "Pagination.first": "первую",
    "Pagination.go_to_page_number": "Перейти на страницу {index}",
    "Pagination.go_to_page": "Перейти на {label} страницу",
    "Pagination.last": "последнюю",
    "Pagination.next": "следующую",
    "Pagination.previous": "предыдущую",
    "Table.actions": "Действия с таблицей",
    "Table.add_column": "Добавить столбец",
    "Table.filter": "Фильтр",
    "Table.hide": "Скрыть",
    "Table.more_actions": "Больше действий",
    "Table.move_left": "Передвинуть влево",
    "Table.move_right": "Передвинуть вправо",
    "Table.not_specified": "Не указано",
    "Table.pagination": "Пагинация таблицы",
    "Table.per_page": "На страницу",
    "Table.position_zero": "0 из {total}",
    "Table.position": "{start}-{end} из {total}",
    "Table.search": "Поиск",
    "Table.select_all": "Выбрать все",
    "Table.select_row": "Выбрать {row}",
    "Table.sort_ascending": "Сортировать по возрастанию",
    "Table.sort_descending": "Сортировать по убыванию",
    "TextInput.clear_labelled_input": "Очистить {label}",
    "Ui.clear_all": "Сбросить",
    "Ui.close": "Закрыть",
    "Ui.loading": "Загрузка",
    "Ui.no_results": "Pезультатов не найдено",
    "Ui.number_selected": "Выбрано {number}",
    "Ui.remove": "Удалить",
    "Ui.select_all": "Выбрать все",
    "Ui.show_more": "+ {count} еще"
};

var zh = {
    "Autocomplete.all_number_selected": "所有 {number} 已选择",
    "Autocomplete.all_number": "全部（{number}）",
    "Card.toggle_content": "切换内容",
    "Chip.remove": "消除",
    "DatePicker.next": "下一个",
    "DatePicker.previous": "以前的",
    "Pagination.first": "第一的",
    "Pagination.go_to_page_number": "转到第 {index} 页",
    "Pagination.go_to_page": "转到 {label} 页面",
    "Pagination.last": "最后的",
    "Pagination.next": "下一个",
    "Pagination.previous": "以前的",
    "Table.actions": "表操作",
    "Table.add_column": "添加列",
    "Table.filter": "筛选",
    "Table.hide": "隐藏",
    "Table.more_actions": "更多操作",
    "Table.move_left": "向左移动",
    "Table.move_right": "向右移",
    "Table.not_specified": "未指定",
    "Table.pagination": "表格分页",
    "Table.per_page": "每页",
    "Table.position_zero": "0 {total}",
    "Table.position": "{start}-{end} 共 {total}",
    "Table.search": "搜索",
    "Table.select_all": "全选",
    "Table.select_row": "选择{row}",
    "Table.sort_ascending": "升序",
    "Table.sort_descending": "降序排列",
    "TextInput.clear_labelled_input": "清除{label}",
    "Ui.clear_all": "全部清除",
    "Ui.close": "关闭",
    "Ui.loading": "加载中",
    "Ui.no_results": "没有结果",
    "Ui.number_selected": "已选择 {number}",
    "Ui.remove": "消除",
    "Ui.select_all": "全选",
    "Ui.show_more": "+ {count} 更多"
};

exports.en = en;
exports.es = es;
exports.fr = fr;
exports.ko = ko;
exports.pl = pl;
exports.pt = pt;
exports.ru = ru;
exports.zh = zh;
//# sourceMappingURL=locales.js.map
